import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const ColourRow: StyleRule<{
    isPreview?: boolean;
    useBottomDivider?: boolean;
    showHoverCursor?: boolean;
}> = ({ isPreview, useBottomDivider, showHoverCursor }) => ({
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: isPreview
        ? pxArrayToRem([0, 8, 8, 0])
        : pxArrayToRem([8, 8, 8, 0]),
    alignItems: 'center',
    minHeight: isPreview ? pxToRem(72) : pxToRem(67),
    cursor: showHoverCursor ? 'pointer' : 'default',
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    '&:last-of-type': {
        borderBottom: useBottomDivider
            ? `1px solid rgba(0, 0, 0, 0.2)`
            : 'none',
    },
});

export const ColourName: StyleRule = ({ theme }) => ({
    margin: 0,
    ...theme.siteVariables.textStyles.Text.Medium65,
    fontSize: theme.siteVariables.fontSizes['caption04'],
    lineHeight: pxToRem(17.5),
    color: theme.siteVariables.colors.charcoal['250'],
});

export const ColourDetails: StyleRule = () => ({
    marginTop: pxToRem(1), //pixel perfecrt
    paddingRight: pxToRem(8),
    maxWidth: pxToRem(124),
});

export const ColourCode: StyleRule = ({ theme }) => ({
    margin: 0,
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: theme.siteVariables.fontSizes['caption05'],
    lineHeight: pxToRem(15),
    color: theme.siteVariables.colors.grey['300'],
});

export const ProductLink: StyleRule = ({ theme }) => ({
    margin: 0,
    textDecoration: 'none',
    ...theme.siteVariables.textStyles.Text.Roman55,
    fontSize: theme.siteVariables.fontSizes['caption04'],
    lineHeight: pxToRem(17.5),
    color: theme.siteVariables.colors.charcoal['250'],
    '&:hover': {
        textDecoration: 'underline',
        color: theme.siteVariables.colors.primitive.black,
    },
});

export const rowAnimation = {
    open: {
        opacity: 1,
        transform: `translateX(${pxToRem(0)})`,
        transition: { duration: 0.2 },
    },
    closed: {
        opacity: 0,
        transform: `translateX(${pxToRem(-8)})`,
        transition: { duration: 0.2 },
    },
};
